<template>
  <section
    :id="shopifyData.sectionId"
    v-lenis-scroll
    class="katrina-series-hero"
    :style="sectionStyles"
  >
    <div class="katrina-series-hero_container">
      <div class="katrina-series_content">
        <div class="video_container">
          <div class="video_overlay" />
          <video
            :key="`video-${shopifyData.sectionId}`"
            :ref="`videoElement-${shopifyData.sectionId}`"
            loop
            muted
            controlsList="nodownload"
            disablepictureinpicture
            webkit-playsinline
            playsinline
            preload="auto"
            autoplay
          >
            <source :src="shopifyData.videolink" type="video/mp4" />
          </video>
          <div class="videoControl">
            <!-- Play/Pause Button -->
            <span v-if="!isPaused" class="pauseIcon" @click="togglePlayPause">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="white"
                class="bi bi-pause"
                viewBox="0 0 16 16"
              >
                <path
                  d="M6 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5m4 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5"
                />
              </svg>
            </span>
            <span v-if="isPaused" class="playIcon" @click="togglePlayPause">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="white"
                class="bi bi-play-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393"
                />
              </svg>
            </span>
            <!-- Mute/Unmute Button -->
            <span v-if="isMuted" class="videoMute" @click="toggleMute">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="white"
                class="bi bi-volume-mute-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06m7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0"
                />
              </svg>
            </span>
            <span v-if="!isMuted" class="videoUnMute" @click="toggleMute">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="white"
                class="bi bi-volume-up-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z"
                />
                <path
                  d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z"
                />
                <path
                  d="M8.707 11.182A4.5 4.5 0 0 0 10.025 8a4.5 4.5 0 0 0-1.318-3.182L8 5.525A3.5 3.5 0 0 1 9.025 8 3.5 3.5 0 0 1 8 10.475zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div class="katrina-series_content katrina-seriesMobBg" :style="mobBgStyles">
        <span class="katrina-series_img">
          <img
            v-lazy="shopifyData.imgText"
            alt="Text Image"
            loading="lazy"
            aria-hidden="true"
            aria-label="Text Image"
            width=""
            height=""
          />
        </span>
        <p class="katrina-series_info">
          {{ shopifyData.sectionInfo }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isPaused: false, // State for video playback
      isMuted: true, // State for audio
      windowWidth: window.innerWidth, // Reactive window width
    };
  },
  computed: {
    sectionStyles() {
      // Dynamic styles for the section
      return {
        paddingTop: `${this.windowWidth > 768 ? this.shopifyData.secDeskPaddingTop : this.shopifyData.secMobPaddingTop}px`,
        paddingBottom: `${this.windowWidth > 768 ? this.shopifyData.secDeskPaddingBottom : 0}px`,
        background: this.windowWidth > 768 ? `url(${this.shopifyData.desktopBannerBg})` : 'none',
      };
    },
    mobBgStyles() {
      // Dynamic styles for the mobile view
      return {
        paddingTop: `${this.windowWidth <= 768 ? this.shopifyData.spaceTopMob : 0}px`,
        background: this.windowWidth <= 768 ? `url(${this.shopifyData.mobBannerBg})` : 'none',
        paddingBottom: `${this.windowWidth <= 768 ? this.shopifyData.secMobPaddingBottom : 0}px`,
      };
    },
  },
  mounted() {
    this.initVideo();
    window.addEventListener('resize', this.handleResize); // Listen to window resize
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize); // Cleanup on component destroy
  },
  methods: {
    togglePlayPause() {
      // Play or pause the video
      const video = this.getVideoElement();
      if (!video) return;

      if (this.isPaused) {
        video
          .play()
          .then(() => {
            this.isPaused = false;
          })
          .catch((error) => {
            console.error('Video play failed:', error);
          });
      } else {
        video.pause();
        this.isPaused = true;
      }
    },
    toggleMute() {
      // Mute or unmute the video
      const video = this.getVideoElement();
      if (!video) return;

      this.isMuted = !this.isMuted;
      video.muted = this.isMuted;
    },
    handleResize() {
      // Update window width on resize
      this.windowWidth = window.innerWidth;
    },
    getVideoElement() {
      // Get video element reference safely
      const refKey = `videoElement-${this.shopifyData.sectionId}`;
      return this.$refs[refKey] || null;
    },
    initVideo() {
      // Initialize the video element on mount
      const video = this.getVideoElement();
      if (video) {
        video.muted = this.isMuted;
        video.play().catch((error) => {
          console.warn('Autoplay might not be allowed:', error);
        });
      } else {
        console.error(`Video element not found for section: ${this.shopifyData.sectionId}`);
      }
    },
  },
};
</script>

<style scoped>
.katrina-series-hero {
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
}

.katrina-series-hero_container {
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  /* align-items: center; */
  padding: 0 20px;
}
video {
  display: block !important;
  visibility: visible !important;
  width: 100%;
  height: auto;
}

.video_container {
  position: relative;
  max-width: 328px;
  width: 100%;
}

.videoControl {
  position: absolute;
  bottom: 5px;
  left: 50%;
  width: 90%;
  display: flex;
  justify-content: space-between;
  transform: translateX(-50%);
}

.katrina-series_content {
  max-width: 50%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.katrina-series_info {
  font-family: 'PP Editorial New', sans-serif;
  font-size: 16px;
  font-style: italic;
  font-weight: 200;
  line-height: 20.48px;
  letter-spacing: 0.02em;
  text-align: right;
  margin-top: 37px;
  color: #fff;
}

.katrina-series_img img {
  display: block;
}

@media (max-width: 768px) {
  .katrina-seriesMobBg {
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
    padding-left: 43px;
    padding-right: 43px;
  }

  .katrina-series-hero_container {
    max-width: 100%;
    display: flex;
    flex-direction: column-reverse;
    padding: 0;
  }

  .katrina-series_content {
    max-width: 100%;
    width: 100%;
  }

  .video_container {
    position: relative;
    max-width: 100%;
    width: 100%;
  }
}
</style>
